import React from "react";
import AppStrokeIcon, { type IAppNavIconProps } from "./AppStrokeIcon";

/** `profile_inactive_icon.svg`. */
const ProfileIcon: React.FC<IAppNavIconProps> = (props) => (
  <AppStrokeIcon {...props}>
    <path d="M12.16 10.87C12.06 10.86 11.94 10.86 11.83 10.87C9.45 10.79 7.56 8.84 7.56 6.44C7.56 3.99 9.54 2 12 2C14.45 2 16.44 3.99 16.44 6.44C16.43 8.84 14.54 10.79 12.16 10.87Z" />
    <path d="M7.16 14.56C4.74 16.18 4.74 18.82 7.16 20.43C9.91 22.27 14.42 22.27 17.17 20.43C19.59 18.81 19.59 16.17 17.17 14.56C14.43 12.73 9.92 12.73 7.16 14.56Z" />
  </AppStrokeIcon>
);

export default ProfileIcon;
